import { IAction } from '@r1-frontend/shared/types/Redux';

import { ECitySelect } from './index';

export type TOpenCitySelect = IAction<ECitySelect.OPEN_CITYSELECT, null>;

const openCitySelect = (): TOpenCitySelect => ({
    type: ECitySelect.OPEN_CITYSELECT,
    payload: null,
});

export default openCitySelect;
